module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('label', {
    staticClass: "full"
  }, [_vm._v("Country")]), _vm._v(" "), (_vm.selectedCountry) ? _c('vSelect', {
    attrs: {
      "label": "name",
      "placeholder": "Pick a country",
      "options": _vm.getCountries
    },
    on: {
      "input": _vm.updateCountry
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-667aada8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-667aada8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/LocationFields.vue
// module id = 1617
// module chunks = 0